import { useLocation, useNavigate, useParams } from "react-router-dom";
import AddPackage from "./AddPackage";

const AddPackagePage = () => {
  const navigate = useNavigate();
  const { packageId: packageIdParam } = useParams();
  const location = useLocation();
  const state = location.state || {};
  const returnTo = state.returnTo || "/packages";
  const parsedPackageId = packageIdParam ? Number(packageIdParam) : null;

  const handleClose = () => {
    navigate(returnTo);
  };

  const handlePackageCreated = (newPackageId) => {
    navigate(`/packages/${newPackageId}/edit`, {
      replace: true,
      state: location.state,
    });
  };

  return (
    <AddPackage
      packageId={parsedPackageId}
      onClose={handleClose}
      onPackageCreated={handlePackageCreated}
      backLabel="Back"
      addSubPackageId={state.addSubPackageId ?? null}
      restrictedTourType={state.restrictedTourType ?? null}
      selectedGroupPackageCount={state.selectedGroupPackageCount ?? null}
      initialTab={state.initialTab ?? null}
    />
  );
};

export default AddPackagePage;
